var BaseGeneralAppConfigView = require("./BaseGeneralAppConfigView");
var Utils = require("common/Utils");

/**
 * @extends {BaseGeneralAppConfigView}
 * @constructor
 */
function GeneralAppConfigView() {
    BaseGeneralAppConfigView.call(this);
}

Utils.inherits(GeneralAppConfigView, BaseGeneralAppConfigView);

module.exports = GeneralAppConfigView;